import { z } from 'zod';
/** Dados estruturados que os especialistas entregam ao app e ao Secretário. */
export const weatherDaySchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    condition: z.string(),
    /** Ícone simples para a tela: sol, nuvem, chuva, tempestade, neblina. */
    icon: z.enum(['sun', 'partly', 'cloud', 'fog', 'rain', 'storm']),
    min: z.number().int(),
    max: z.number().int(),
    rainChance: z.number().int().min(0).max(100).nullable(),
});
export const weatherForecastSchema = z.object({
    city: z.string(),
    source: z.literal('Open-Meteo'),
    updatedAt: z.iso.datetime(),
    days: z.array(weatherDaySchema),
});
export const briefingItemSchema = z.object({
    kind: z.enum(['appointment', 'reminder']),
    title: z.string(),
    /** Horário de Brasília, HH:MM. */
    time: z.string(),
    detail: z.string().nullable(),
});
export const dailyBriefingSchema = z.object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    greeting: z.string(),
    weather: weatherDaySchema.extend({ city: z.string() }).nullable(),
    agenda: z.array(briefingItemSchema),
    pendingApprovals: z.number().int().nonnegative(),
    generatedAt: z.iso.datetime(),
});
